import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import {
  ICreateRecipePayload,
  IUpdateRecipePayload,
} from "../../interfaces/store/recipe-interface";

export const getRecipeApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.recipes.getRecipe}?recipeId=${id}`
  );
};

export const createRecipeApi = async (data: ICreateRecipePayload) => {
  return await axiosInstance.post(
    AXIOS_ROUTES.recipes.createRecipe,
    data.recipe
  );
};

export const updateRecipeApi = async ({
  recipeId,
  recipe,
}: IUpdateRecipePayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.recipes.updateRecipe}?recipeId=${recipeId}`,
    recipe
  );
};

export const deleteRecipeApi = async (recipeId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.recipes.deleteRecipe}?recipeId=${recipeId}`
  );
};

export const searchRecipesApi = async (data: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.recipes.search, data);
};
